import { ExceededCreditsCardComponent } from "./components/exceeded-credits-card";
import { ExceededCreditsCardSkeleton } from "./components/exceeded-credits-card-skeleton";
import { useExceededCreditsCard } from "./hooks/exceeded-credits-card.hooks";

export type ExceededCreditsCardProps = {
  companyId: number;
  companyName?: string;
  userId?: number;
  userEmail?: string;
  hookResult?: ReturnType<typeof useExceededCreditsCard>;
  carousel?: boolean;
  isPackageScreen?: boolean;
};

export const ExceededCreditsCard = ({
  companyId,
  companyName,
  userId,
  userEmail,
  hookResult,
  carousel = false,
  isPackageScreen = false,
}: ExceededCreditsCardProps) => (
  <ExceededCreditsCardComponent
    companyId={companyId}
    companyName={companyName}
    userId={userId}
    userEmail={userEmail}
    hookResult={hookResult}
    carousel={carousel}
    isPackageScreen={isPackageScreen}
  />
);

export { ExceededCreditsCardSkeleton, useExceededCreditsCard };
